export default __webpack_public_path__ + "static/media/ea_expectations.d2152909.png";